import { useClassNames } from "@/utils/classNames";

import { Icon, StreamingIcons } from "../Icon";
import { SkipButtonProps, SkipDirection } from "./types";
import styles from "./SkipButton.module.scss";

/**
 * Skip button for video player controls (forward or backward)
 *
 * @param props - The button properties
 * @returns the skip button component
 */
const SkipButton = ({
  direction,
  seconds,
  onClick,
  ariaLabel,
  className,
}: SkipButtonProps) => {
  const defaultLabel =
    direction === SkipDirection.Forward
      ? `Skip forward ${seconds} seconds`
      : `Skip backward ${seconds} seconds`;

  const cn = useClassNames(styles, styles["skip-button"], className);

  const icon =
    direction === SkipDirection.Backward
      ? StreamingIcons.Back10sec
      : StreamingIcons.Fwd10sec;

  return (
    <button
      className={cn}
      onClick={onClick}
      aria-label={ariaLabel || defaultLabel}
      type="button"
    >
      <Icon className={styles.icon} icon={icon} />
    </button>
  );
};

export { SkipButton };
